import PropTypes from 'prop-types';
import React from 'react';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import TeasePicture from 'components/TeasePicture';
import TypeIcon from 'components/TypeIcon';

function VideoListItemImage(props) {
  const {
    altText,
    url,
    previewURL,
  } = props;

  const responsiveFlavors = {
    s: AIMS_FLAVORS.FOCAL_120x120,
  };

  const previewConfiguration = {
    url: previewURL,
    redirect: false,
    radius: true,
  };

  return (
    <div className="ontheshow-video-list-item-image">
      <TeasePicture
        className="ontheshow-video-list-item-image__tease-image"
        url={url}
        responsiveFlavors={responsiveFlavors}
        alt={altText}
        preview={previewConfiguration}
        retina
      />
      <TypeIcon
        type="video"
      />
    </div>
  );
}

VideoListItemImage.propTypes = {
  altText: PropTypes.string,
  previewURL: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

VideoListItemImage.defaultProps = {
  altText: '',
};

export default VideoListItemImage;
